import { Landmark, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "@/store/hooks";

interface Props {
  assetName?: string;
}

const FiatWithdrawalNotice = ({ assetName }: Props) => {
  const { theme } = useAppSelector((state) => state.ui);

  const navigate = useNavigate();

  return (
    <div
      className={`rounded-xl border p-6 ${
        theme === "dark"
          ? "border-primary/20 bg-primary/5"
          : "border-primary/20 bg-primary/5"
      }`}
    >
      <div className="flex flex-col md:flex-row gap-4">
        <div className="rounded-full bg-primary/10 p-3 h-fit w-fit">
          <Landmark className="w-6 h-6 text-primary" />
        </div>

        <div className="flex-1">
          <h3 className="font-semibold text-lg">Fiat Withdrawal</h3>

          <p className="text-sm text-muted-foreground mt-2 leading-6">
            <strong>{assetName}</strong> is a fiat-backed asset. Blockchain
            withdrawals are not supported for fiat assets because they represent
            real-world fiat currencies. To withdraw your funds to a bank
            account, you must first create or accept a P2P advertisement.
          </p>

          <div className="mt-5 rounded-lg bg-yellow-500/10 border border-yellow-500/20 p-4">
            <p className="text-sm text-yellow-600">
              Fiat withdrawals are completed through verified P2P trades. This
              provides compliance, fraud protection, and secure settlement
              between buyers and sellers.
            </p>
          </div>

          <button
            onClick={() => navigate("/p2p")}
            className="mt-6 inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-3 font-medium text-black hover:brightness-110 transition-all"
          >
            Go to P2P Marketplace
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiatWithdrawalNotice;
